import mutations from './eprofileTerhesseg.mutations'
import actions from './eprofileTerhesseg.actions'
import getters from './eprofileTerhesseg.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
